import gql from 'graphql-tag'
import _ from 'lodash'

export default config =>
  async (payload = {}) => {
    const { client, table, defaultFilters, fetchPolicy } = config

    let { filters = defaultFilters } = payload

    const query = gql`
          query(
            $filters: ${table}_bool_exp!
          ) {
            meta: ${table}_aggregate(
              where: {
                _and: [
                  $filters
                ]
              }
            ) {
              aggregate {
                count
              }
            }
          }
    `

    let variables = {
      filters: !_.isEmpty(filters) ? { _and: [...filters] } : null
    }

    let { data } = await client.query({
      fetchPolicy,
      query,
      variables
    })

    return {
      count: data.meta.aggregate.count
    }
  }
